import SearchBar from './SearchBar'

SearchBar.install = function install (Vue) {
  Vue.component(SearchBar.name, SearchBar)
}

export default SearchBar



// WEBPACK FOOTER //
// ./src/components/search-bar/index.js